module.exports = __webpack_public_path__ + "img/slideImage_koke.0ab06a5a.jpg";